<template>
	<div>
		<div id="non-printable-area">
			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">Statement</v-toolbar-title>

				<v-spacer></v-spacer>

				<v-menu>
					<v-btn icon small slot="activator"><v-icon font20>more_vert</v-icon></v-btn>
					<v-list dense nopadding>
						<v-list-tile @click="fn_changeTheme(1)">
							<v-list-tile-content>
								<v-list-tile-title>Color</v-list-tile-title>	
							</v-list-tile-content>
							<v-list-tile-action>
								<v-icon>{{ statementTheme == 1 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile @click="fn_changeTheme(2)">
							<v-list-tile-content>
								<v-list-tile-title>Black &amp; White</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-icon>{{ statementTheme == 2 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
				</v-menu>

			</v-toolbar>

			<div class="hasToolbar hasBigFooterWithExtention">

				<v-subheader class="pl-2 pr-2 font12" white-background subheader-dense dark-opacity-color font-normal>
					<span @click="fn_openDialogCustomDates">
						Period:&nbsp;{{startDate | moment("DD-MMM-YYYY")}}&nbsp;To&nbsp;{{endDate | moment("DD-MMM-YYYY")}}
					</span>
					<v-spacer></v-spacer>
					<v-menu>
		                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">
		                	{{selectedPeriod}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
		                <v-list nopadding>
		                  <v-list-tile v-for="(item, index) in periods" :key="index" @click="fn_dateRange(item)">
		                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
		                  </v-list-tile>
		                </v-list>
		            </v-menu>
				</v-subheader>

				<v-divider v-if="statementTheme == 2"></v-divider>

				<div>
					<ledger-statement ref="ref_ledgerStatement" :statementData="statementData" :statementType="statementType" :opening="displayData.opening" :statementView="true" :statementTheme="statementTheme" v-if="statementData"></ledger-statement>
				</div>

			</div>

			<v-footer class="invoice-footer-actions">
		    	<v-layout grid white-background wrap text-xs-center>

					<v-flex xs4 sm4 md4 pt-2 pb-2 @click="fn_checkPermission('sharewhatsapp')">
						<div right-border>
							<div style="height:26px"><img src="../../../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
					    	<div font11 class="font-weight-bold">Send</div>
						</div>
					</v-flex>

					<v-flex xs4 sm4 md4 pt-2 pb-2 @click="fn_checkPermission('share')">
						<div right-border>
							<div><v-icon>share</v-icon></div>
					    	<div font11 class="font-weight-bold">Share</div>
						</div>
					</v-flex>

					<v-flex xs4 sm4 md4 pt-2 pb-2 @click="fn_checkPermission('download')">
						<div right-border>
							<div><v-icon>vertical_align_bottom</v-icon></div>
					    	<div font11 class="font-weight-bold">Download</div>
						</div>
					</v-flex>

				</v-layout>

		    </v-footer>
		</div>

		<dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

		<dialog-period-selection ref="ref_dialogCustomPeriod" title="Select Period" :openDatePicker="fn_openDatePicker" :startDate="selectedStartDate" :endDate="selectedEndDate" :actionMethod="fn_updateCustomDates"></dialog-period-selection>

		<div id="printable-area" white-background full-width>
			<ledger-statement ref="ref_ledgerStatement" :statementData="statementData" :statementType="statementType" :opening="displayData.opening" :statementTheme="statementTheme" v-if="statementData"></ledger-statement>
		</div>

		<v-snackbar v-model="snackbar">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>

        <!-- <v-snackbar v-model="infoSnackbar">
          Selected period is not applicable!
          <v-btn text color="primary" @click.native="infoSnackbar=false">Close</v-btn>
        </v-snackbar> -->

	</div>
</template>

<script>

import ledgerStatement from './ledger_statement'
import dialogDatepicker from './dialogs/dialog_datepicker'
import dialogPeriodSelection from '../../../dialogs/dialog_period_selection'

	export default{
		props:['settings'],
		components: {
		    'ledger-statement':ledgerStatement,
		    'dialog-datepicker':dialogDatepicker,
		    'dialog-period-selection':dialogPeriodSelection
		},
		data(){
			return{
				startDate:this.$root.minDateSelection,
				endDate:this.$root.maxDateSelection,
				displayData:null,
				statementData:null,
		        statementType:1,
		        periods:[{'title':'Last 7 Days', "value":7}, {'title':'Last 30 Days', "value":30}, {'title':'All Time', "value":0}, {'title':'Custom', "value":null}],
		        selectedPeriod:"All Time",
		        selectedDate:null,
		        dateType:null,
		        snackbar:false,
		        selectedStartDate:null,
		        selectedEndDate:null,
				statementTheme:1
                // infoSnackbar:false
			}
		},
		methods:{

			fn_get: function(){
				var self = this;
				this.showLoading('Loading details...');
		  		this.getData('Ledger', this.$route.params.tagId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.displayData = JSON.parse(response);
                            self.fn_getLastTransactionDate();
							// self.fn_getLedgerStatement();
				        }, 
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				        }
					}
		        );
			},

            fn_getLastTransactionDate: function(){
                let self = this;
                let filterObject = {};
                // Sending opening stock and opening ledger list id to get first transaction date except these two.
                filterObject.transactionListId = [40001, 40003];
                this.getFilterData('LastTransactionDate', null, filterObject,
                    {
                        onSuccess: function(response){
                        console.log(response);
                        let ltd = JSON.parse(response);
                        self.fn_getLedgerStatement(ltd);
                    },
                        onError: function(error){
                        console.log(error);
                    }
                });
            },

			fn_getLedgerStatement: function(ltd){
		        let filterObject = {};
		        filterObject.reportId = 201;

		        // if(new Date(this.startDate).getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
		        // 	this.startDate = this.$root.CurrentBusiness.OpeningDate;
		        // }

				if(new Date(this.endDate) > new Date(this.$root.maxDateSelection)){
                    // alert('in');
                    this.endDate = new Date(this.$root.maxDateSelection);
                }

				if(ltd && new Date(ltd) < new Date(this.endDate)){
                    this.endDate = new Date(ltd);
                }

				if(new Date(this.startDate) > new Date(this.endDate)){
                    // this.$eventHub.$emit('snackbarAlert', {msg:'Selected period is not applicatble'});
					this.showToast('Selected period is not applicatble');
                    this.startDate = this.endDate;
                }

		        filterObject.startDate = this.$moment(this.startDate).startOf('day'); //new Date(this.startDate);
		        filterObject.endDate = this.$moment(this.endDate).endOf('day');

		        filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
		        filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);
		        
		        let self = this;
		        this.getReportData('Report', this.$route.params.tagId, filterObject,{

		            onSuccess: function(response){
		                console.log(response);
		                self.statementData = JSON.parse(response);
		                self.statementData.accountDetails = {};
		                self.statementData.accountDetails.accountName = self.displayData.name;
		                self.statementData.accountDetails.startDate = self.startDate;
		                self.statementData.accountDetails.endDate = self.endDate;
		                self.statementData.accountDetails.primaryMobileNumber = self.displayData.primaryMobileNumber
		                self.statementData.accountDetails.email = self.displayData.email;
						self.statementData.accountDetails.gstNumber = self.displayData.gstNumber;
						self.statementData.accountDetails.groupTypeId = self.displayData.groupTypeId;
		                self.fn_statementSummary();
		                console.log(self.statementData);
		            }, 
		            onError: function(error){
		                console.log(error);
		                self.hideLoading();
		            }

		        });
		    },

		    fn_statementSummary: function(){
		    	// this.statementData.accountDetails.opening = this.displayData.opening ? this.displayData.opening : 0;
		    	this.statementData.accountDetails.opening = this.statementData.data.footerRow && this.statementData.data.footerRow.openingValue ? this.statementData.data.footerRow.openingValue : 0;

		    	this.statementData.accountDetails.debitTotal = this.statementData.data.footerRow && this.statementData.data.footerRow.debit ? this.statementData.data.footerRow.debit : 0;
		    	this.statementData.accountDetails.creditTotal = this.statementData.data.footerRow && this.statementData.data.footerRow.credit ? this.statementData.data.footerRow.credit : 0;

	    		// if(this.displayData.opening > 0){
	    		// 	this.statementData.accountDetails.debitTotal = this.roundUpto2Decimals(this.statementData.data.footerRow.debit - this.displayData.opening); 
	    		// }
	    		// else if(this.displayData.opening < 0){
	    		// 	this.statementData.accountDetails.creditTotal = this.roundUpto2Decimals(this.statementData.data.footerRow.credit + this.displayData.opening);
	    		// }

	    		// if(this.statementData.accountDetails.opening > 0){
	    		// 	this.statementData.accountDetails.debitTotal = this.roundUpto2Decimals(this.statementData.data.footerRow.debit - this.statementData.accountDetails.opening); 
	    		// }
	    		// else if(this.statementData.accountDetails.opening < 0){
	    		// 	this.statementData.accountDetails.creditTotal = this.roundUpto2Decimals(this.statementData.data.footerRow.credit + this.statementData.accountDetails.opening);
	    		// }

	    		this.statementData.accountDetails.balance = this.statementData.data.footerRow && this.statementData.data.footerRow.partyBalance ? this.statementData.data.footerRow.partyBalance : 0;

				this.statementData.accountDetails.creditDebitType = this.statementData.data.footerRow && this.statementData.data.footerRow.creditDebitType ? this.statementData.data.footerRow.creditDebitType : '';

                this.hideLoading();
		    },

		    fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : new Date();
				setTimeout(function () {
					// self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
					self.$refs['ref_dialogDatePicker'].openDialogWeb();
				});
			},

			fn_openDialogCustomDates: function(){
				this.selectedStartDate = this.startDate;
				this.selectedEndDate = this.endDate;
				this.$refs['ref_dialogCustomPeriod'].openDialogWeb();
			},

		    fn_updateDate: function (value) {
				if(this.dateType=="start"){
					this.selectedStartDate = value;
				}
				else if(this.dateType=="end"){
					this.selectedEndDate = value;
				}

				this.fn_closeDialog();

				this.selectedPeriod = null;

				// this.fn_getLedgerStatement();
			},

			fn_updateCustomDates: function(){
				this.startDate = this.selectedStartDate;
				this.endDate = this.selectedEndDate;
				this.selectedPeriod = "Custom";
				this.fn_closeDialog();
				// this.fn_getLastTransactionDate();
                this.fn_getLedgerStatement();
			},

			fn_closeDialog: function(){
				if(this.$refs['ref_dialogDatePicker'].datepicker){
					this.$refs['ref_dialogDatePicker'].closeDialogWeb();
					return;	
				}

				if(this.$refs['ref_dialogCustomPeriod'].dialog_period_selection){
					this.$refs['ref_dialogCustomPeriod'].closeDialogWeb();
				}
			},

		    fn_dateRange:  function (item){

				if(item.value==7){
				  	let date = new Date();
				  	date.setDate(date.getDate() - 6);
				  	this.startDate = date
				    this.endDate = new Date();
				    this.selectedPeriod = item.title;
				}
				else if(item.value==30){
				  	let date = new Date();
				  	date.setDate(date.getDate() - 30);
				  	this.startDate = date;
				    this.endDate = new Date();
				    this.selectedPeriod = item.title;
				}	
				else if(item.value==0){
				  	this.startDate = this.$root.minDateSelection;
				    this.endDate = this.$root.maxDateSelection;
				    this.selectedPeriod = item.title;
				}
				else{
					this.selectedPeriod = null;
					this.fn_openDialogCustomDates();
				}

                if(new Date(this.endDate) < new Date(this.$root.CurrentBusiness.OpeningDate)){
                    this.startDate = this.endDate;
                    // this.infoSnackbar = true;
                    this.showToast("Selected period is not applicable!");
                }

				if(item.value!=null){
					if(item.value==0){
						this.fn_getLastTransactionDate();
					}
					else{
						this.fn_getLedgerStatement();
					}
					// this.fn_getLedgerStatement();
				}

				// let self = this;
				// this.$root.fn_checkStoragePermission(function(){
				// 	self.fn_closeDialog();
				// 	self.statementType == 1 ? self.fn_getLedgerStatement(type) : self.fn_getLedgerActivity(type);
				// })

			},

			fn_checkPermission: function(type){
				let self = this;
				this.$root.fn_checkStoragePermission(function(){
					self.fn_exportStatementToPdf(type);
				})
			},

			fn_exportStatementToPdf: function(type){
		        let self = this;
		        let downloadTime = new Date();
		        let fileName = null;

		        let ledgerName = this.displayData.name.replace(/\//g,'');

		        if(this.statementType == 1){
		        	fileName = "LedgerStatement-"+ledgerName + '_' + this.$root.fn_getCurrentDateTimeString()+".pdf";
		        }
		        else{
		        	fileName = "LedgerActivity-"+ledgerName + '_' + this.$root.fn_getCurrentDateTimeString()+".pdf";
		        }

		        this.exportToPdf(fileName, 'false',{

		          onSuccess: function(response){
		              console.log(response);
		              if(type=='download'){
		              	self.snackbar = true;
		              }
		              else{
		              	self.fn_shareStatement(type);
		              }
		          }, 
		          onError: function(error){
		              console.log(error);
		              self.hideLoading();
		              self.showToast('Something went wrong. Try again');
		          }
		        });
		    },

		    fn_shareStatement: function(type){
				let shareObj = {};
				// shareObj.shareType = 'share';
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				shareObj.type = 'pdf';
				shareObj.primaryMobileNumber = this.displayData.primaryMobileNumber ? this.displayData.primaryMobileNumber : null;
				// shareObj.subject = this.statementType == 1 ? "Ledger Statement" : "Ledger Activity";
				let title = this.statementType == 1 ? "Ledger Statement" : "Ledger Activity";
				shareObj.subject = title + " from " + this.$root.CurrentBusiness.BusinessName;
				shareObj.email = this.displayData.email ? [this.displayData.email] : null ;

				let party = this.displayData.name ? this.displayData.name + ',' : '';
				shareObj.textMessage = this.$tShare('share.documentAttached', {
					party: party,
					title: title,
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				this.$root.fn_share(shareObj);
			},

			fn_changeTheme: function(value){
				this.statementTheme = value;
				this.$root.fn_saveLocalItem({LocalKey:'statement_theme',LocalValue:value});
			},

			fn_goBack: function(){
				this.$router.go(-1);
			},


			
		},
		mounted: function(){
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.$root.fn_getLocalItem('statement_theme', response=>{
				let data = JSON.parse(response);
				if(data && data.LocalValue){
					this.statementTheme = data.LocalValue ? data.LocalValue : 1;
				}
			})

			this.fn_get();
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDatePicker'].datepicker){
				this.$refs['ref_dialogDatePicker'].closeDialogWeb();
				next(false);
			}
			else if(this.$refs['ref_dialogCustomPeriod'].dialog_period_selection){
				this.$refs['ref_dialogCustomPeriod'].closeDialogWeb();
				next(false);	
			}
			else{
				next(true);
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/ledger_statement_view.vue